import _jsx from "@babel/runtime/helpers/jsx";
import { Helmet } from 'react-helmet-async';
import React, { useMemo, memo } from 'react';
import { Nav, List, ListItem, Link, CurrentPage } from './styles';

var last = function last(list) {
  return list[list.length - 1];
};

var withoutLast = function withoutLast(list) {
  return list.slice(0, -1);
};

var getFullURL = function getFullURL(path) {
  return "".concat(process.env.APP_MINFIN_DOMAIN).concat(path).concat(!path.endsWith('/') ? '/' : '');
};

function BreadCrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;

  var _last = last(breadcrumbs),
      currentPageName = _last.name;

  var helmetScript = useMemo(function () {
    return [{
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map(function (_ref2, index) {
          var name = _ref2.name,
              link = _ref2.link;
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': getFullURL(link),
              name: name
            }
          };
        })
      })
    }];
  }, [breadcrumbs]);
  return /*#__PURE__*/_jsx(Nav, {}, void 0, /*#__PURE__*/_jsx(Helmet, {
    script: helmetScript
  }), /*#__PURE__*/_jsx(List, {}, void 0, withoutLast(breadcrumbs).map(function (_ref3) {
    var link = _ref3.link,
        name = _ref3.name;
    return /*#__PURE__*/_jsx(ListItem, {}, link, /*#__PURE__*/_jsx(Link, {
      href: getFullURL(link)
    }, void 0, name));
  }), /*#__PURE__*/_jsx(ListItem, {}, void 0, /*#__PURE__*/_jsx(CurrentPage, {
    "aria-current": "page"
  }, void 0, currentPageName))));
}

BreadCrumbs.defaultProps = {
  breadcrumbs: []
};
export default /*#__PURE__*/memo(BreadCrumbs);